import * as actions from "./actions";
import { rootRef } from "../../config/firebase";

function obtenerListaActividades() {
  return dispatch => {
    rootRef.child("detalles/actividades").on("child_added", snap => {
      const payload = { ...snap.val(), ...{ id: snap.key } };
      dispatch(actions.obtenerListaActividades(payload));
    });
  };
}

function resetListaActividades() {
  return actions.resetListaActividades();
}

function resetDetalleActividad() {
  return actions.resetDetalleActividad();
}

function obtenerDetalleActividad(value) {
  return dispatch => {
    rootRef.child(`detalles/actividades/${value}`).once("value", snap => {
      const payload = { ...snap.val(), ...{ id: snap.key } };
      dispatch(actions.obtenerDetalleActividad(payload));
    });
  };
}

function saveDataActividad(values) {
  const idActividad = rootRef.child("detalles/actividades").push().key;
  values.nombre = values.nombre.trim().toUpperCase();
  values.importe = values.importe.trim().toUpperCase();
  values.descripcion = values.descripcion
    ? values.descripcion.trim().toUpperCase()
    : "";
  let insert = {};
  insert[`detalles/actividades/${idActividad}`] = values;
  return dispatch => rootRef.update(insert);
}

function updateDataActividad(values) {
  values.nombre = values.nombre.trim().toUpperCase();
  values.importe = values.importe.trim().toUpperCase();
  values.descripcion = values.descripcion.trim().toUpperCase();
  let insert = {};
  insert[`detalles/actividades/${values.id}`] = values;
  return dispatch => rootRef.update(insert);
}

/*---*/
export {
  obtenerDetalleActividad,
  resetDetalleActividad,
  obtenerListaActividades,
  resetListaActividades,
  saveDataActividad,
  updateDataActividad
};



// WEBPACK FOOTER //
// ./src/ducks/actividades/operations.js